import getStore from '../store';

const initialState = window.__INITIAL_STATE__;  
const store = getStore(initialState);

window.store = store;

export default store;
